import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Modal, Inner, Spinner, Text } from "./styles/updating-styles";
import spinner from "./img/spinner-white.gif";

const Updating = ({ loading }) => (
  <Wrapper className={loading && "active"}>
    <Modal>
      <Inner>
        <Spinner src={spinner} alt="Saving spinner" />
        <Text>Updating...</Text>
      </Inner>
    </Modal>
  </Wrapper>
);

Updating.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default Updating;
